export class CrewstackSdkError extends Error {
    code;
    status;
    details;
    retryAfterSeconds;
    /**
     * True only for a 401 whose `WWW-Authenticate` names `invalid_token`: the Platform refused the access
     * token before the route ran, so sending the request again with a renewed token cannot do anything
     * twice. Any other 401 (an owner error mapped to 401) says nothing about whether the route ran and is
     * never resent.
     */
    accessTokenRejected;
    constructor(options) {
        super(options.message);
        this.name = 'CrewstackSdkError';
        this.code = options.code;
        this.accessTokenRejected = options.accessTokenRejected === true;
        if (options.status !== undefined) {
            this.status = options.status;
        }
        else {
            this.status = null;
        }
        this.details = options.details;
        if (options.retryAfterSeconds === undefined) {
            this.retryAfterSeconds = null;
        }
        else if (Number.isSafeInteger(options.retryAfterSeconds) && options.retryAfterSeconds >= 0) {
            this.retryAfterSeconds = options.retryAfterSeconds;
        }
        else {
            throw new TypeError('retryAfterSeconds must be a non-negative safe integer.');
        }
    }
    toJSON() {
        return {
            code: this.code,
            message: this.message,
            status: this.status,
            ...(this.details === undefined ? {} : { details: this.details }),
            ...(this.retryAfterSeconds === null ? {} : { retryAfterSeconds: this.retryAfterSeconds }),
        };
    }
}
export function isCrewstackSdkError(error) {
    return error instanceof CrewstackSdkError;
}
export class CrewstackDomainDecodeError extends Error {
    domain;
    field;
    payload;
    constructor(options) {
        super(options.message);
        this.name = 'CrewstackDomainDecodeError';
        this.domain = options.domain;
        this.field = options.field;
        this.payload = options.payload;
    }
    toJSON() {
        return {
            domain: this.domain,
            field: this.field,
            message: this.message,
            ...(this.payload === undefined ? {} : { payload: this.payload }),
        };
    }
}
export function isCrewstackDomainDecodeError(error) {
    return error instanceof CrewstackDomainDecodeError;
}
//# sourceMappingURL=errors.js.map